import { atom, useAtom } from "jotai";

import { type TransformedOrderbook } from "#/types/orderbook";

export const perpsOrderbookAtom = atom<TransformedOrderbook>({
  buys: [],
  sells: [],
  midPrice: NaN,
});

export const usePerpsOrderbook = () => {
  const [perpsOrderbook, setPerpsOrderbook] = useAtom(perpsOrderbookAtom);

  return {
    perpsOrderbook,
    setPerpsOrderbook,
  };
};
